import { type SvgProps, SvgWrapper } from '../utils';

export function BarChartIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M4.25 21V15C4.25 14.5858 4.58579 14.25 5 14.25C5.41421 14.25 5.75 14.5858 5.75 15V21C5.75 21.4142 5.41421 21.75 5 21.75C4.58579 21.75 4.25 21.4142 4.25 21Z" />
      <path d="M11.25 21V3C11.25 2.58579 11.5858 2.25 12 2.25C12.4142 2.25 12.75 2.58579 12.75 3V21C12.75 21.4142 12.4142 21.75 12 21.75C11.5858 21.75 11.25 21.4142 11.25 21Z" />
      <path d="M18.25 21V9C18.25 8.58579 18.5858 8.25 19 8.25C19.4142 8.25 19.75 8.58579 19.75 9V21C19.75 21.4142 19.4142 21.75 19 21.75C18.5858 21.75 18.25 21.4142 18.25 21Z" />
    </SvgWrapper>
  );
}
